export const STAGES = [
  { title: "FIR Registered", desc: "Police officially record the complaint and the case begins." },
  { title: "Investigation", desc: "Police collect evidence and record statements of witnesses." },
  { title: "Arrest / Notice & Bail", desc: "The accused is arrested or given notice, and may apply for bail." },
  { title: "Charge Sheet Filed", desc: "Police submit their final report with all evidence to the court." },
  { title: "Cognizance by Court", desc: "The judge reviews the charge sheet and decides to proceed." },
  { title: "Framing of Charges", desc: "The court formally lists the offences the accused must answer." },
  {
    title: "Trial",
    desc: "Both sides present witnesses and evidence before the judge.",
    sub: ["Prosecution Evidence", "Statement of Accused", "Defence Evidence", "Final Arguments"],
  },
  { title: "Judgment", desc: "The court announces its final decision in the case." },
  { title: "Appeal (if applicable)", desc: "Either side may challenge the judgment in a higher court." },
];

export const NEXT_LINES = [
  "Police will begin investigating the complaint.",
  "Police will decide on arrest or issue a notice to appear.",
  "Police will file the charge sheet in court.",
  "Court will take cognizance of the charge sheet.",
  "Court will frame the charges against the accused.",
  "The trial will begin with prosecution evidence.",
  "The court will deliver its judgment.",
  "An appeal may be filed in a higher court if needed.",
  "Your case journey is complete.",
];

export const CASES = [
  {
    id: "c1", title: "State vs. Demo Client", number: "Case No. 245/2025", court: "Sessions Court, Pune",
    clientId: "cl1", clientName: "Demo Client", stage: 3, nextHearing: "18 Nov 2026",
    dates: ["12 Aug 2025", "20 Dec 2025", "14 Jan 2026", "28 Oct 2026"],
    updates: [
      { date: "28 Oct 2026", text: "Charge sheet filed by police" },
      { date: "14 Jan 2026", text: "Bail granted" },
      { date: "20 Dec 2025", text: "Investigation completed" },
    ],
  },
  {
    id: "c2", title: "State vs. Demo Client (Cyber Cell)", number: "FIR No. 88/2026", court: "JMFC Court, Shivajinagar, Pune",
    clientId: "cl1", clientName: "Demo Client", stage: 1, nextHearing: "25 Nov 2026",
    dates: ["03 Oct 2026", "10 Oct 2026"],
    updates: [
      { date: "22 Oct 2026", text: "Statements recorded by investigating officer" },
      { date: "10 Oct 2026", text: "Investigation started" },
      { date: "03 Oct 2026", text: "FIR registered at Cyber Police Station" },
    ],
  },
  {
    id: "c3", title: "State vs. Demo Client & Ors.", number: "Bail Appl. No. 1132/2026", court: "District Court, Pune",
    clientId: "cl1", clientName: "Demo Client", stage: 2, nextHearing: "09 Nov 2026",
    dates: ["02 Jun 2026", "30 Aug 2026", "21 Oct 2026"],
    updates: [
      { date: "21 Oct 2026", text: "Bail application filed" },
      { date: "30 Aug 2026", text: "Investigation completed" },
      { date: "02 Jun 2026", text: "FIR registered" },
    ],
  },
  {
    id: "c4", title: "State vs. Rohan Fictus", number: "Case No. 112/2024", court: "Sessions Court, Mumbai",
    clientId: "cl2", clientName: "Rohan Fictus", stage: 5, nextHearing: "12 Nov 2026",
    dates: ["10 Jan 2024", "18 Mar 2024", "02 Apr 2024", "15 Jul 2024", "20 Sep 2024", "05 Oct 2026"],
    updates: [
      { date: "05 Oct 2026", text: "Arguments on framing of charges heard" },
      { date: "20 Sep 2024", text: "Court took cognizance" },
      { date: "15 Jul 2024", text: "Charge sheet filed" },
    ],
  },
  {
    id: "c5", title: "State vs. Meera Sampleton", number: "Case No. 77/2023", court: "Sessions Court, Nashik",
    clientId: "cl3", clientName: "Meera Sampleton", stage: 6, nextHearing: "03 Dec 2026",
    dates: ["04 Feb 2023", "11 Apr 2023", "20 Apr 2023", "30 Jun 2023", "14 Aug 2023", "02 Nov 2023", "10 Jan 2024"],
    updates: [
      { date: "29 Oct 2026", text: "Prosecution witness PW-3 examined" },
      { date: "02 Nov 2023", text: "Charges framed" },
      { date: "14 Aug 2023", text: "Court took cognizance" },
    ],
  },
  {
    id: "c6", title: "State vs. Kabir Placeholder", number: "FIR No. 301/2026", court: "JMFC Court, Thane",
    clientId: "cl4", clientName: "Kabir Placeholder", stage: 0, nextHearing: "To be scheduled",
    dates: ["30 Oct 2026"],
    updates: [{ date: "30 Oct 2026", text: "FIR registered at Naupada Police Station" }],
  },
];

export const CLIENTS = [
  { id: "cl1", name: "Demo Client", phone: "+91 90000 00001", email: "client@demo.com", city: "Pune" },
  { id: "cl2", name: "Rohan Fictus", phone: "+91 90000 00002", email: "rohan@example.com", city: "Mumbai" },
  { id: "cl3", name: "Meera Sampleton", phone: "+91 90000 00003", email: "meera@example.com", city: "Nashik" },
  { id: "cl4", name: "Kabir Placeholder", phone: "+91 90000 00004", email: "kabir@example.com", city: "Thane" },
];

export const STAFF = [
  { id: "s1", name: "Priya Mockwala", role: "Senior Associate", status: "Active" },
  { id: "s2", name: "Arjun Testkar", role: "Junior Associate", status: "Active" },
  { id: "s3", name: "Neha Demoji", role: "Court Clerk", status: "On Leave" },
];

export const PERMISSIONS = [
  { key: "view", label: "View Cases", on: true },
  { key: "edit", label: "Edit Cases", on: true },
  { key: "stage", label: "Update Case Stage", on: true },
  { key: "reply", label: "Reply to Messages", on: true },
  { key: "clients", label: "Manage Clients", on: false },
  { key: "docs", label: "Upload Documents", on: false },
];

export const STATS = [
  { key: "cases", label: "Active Cases", value: 12 },
  { key: "hearings", label: "Upcoming Hearings", value: 4 },
  { key: "messages", label: "Unread Messages", value: 5 },
  { key: "tasks", label: "Pending Tasks", value: 7 },
];

export const HEARINGS = [
  { id: "h1", time: "10:30 AM", caseId: "c5", title: "State vs. Meera Sampleton", court: "Sessions Court, Nashik — Court Room 4", purpose: "Prosecution evidence" },
  { id: "h2", time: "12:00 PM", caseId: "c4", title: "State vs. Rohan Fictus", court: "Sessions Court, Mumbai — Court Room 11", purpose: "Framing of charges" },
  { id: "h3", time: "03:15 PM", caseId: "c3", title: "State vs. Demo Client & Ors.", court: "District Court, Pune — Court Room 2", purpose: "Bail arguments" },
];

export const DEMO_TODAY = "2026-11-05";

export const CALENDAR_HEARINGS = [
  ...HEARINGS.map((h) => ({ ...h, date: DEMO_TODAY })),
  { id: "u1", date: "2026-11-09", time: "11:00 AM", caseId: "c3", title: "State vs. Demo Client & Ors.", court: "District Court, Pune", purpose: "Bail order pronouncement", reachBy: "10:30 AM", bring: ["Original ID proof (Aadhaar or PAN card)", "Copy of your bail application", "Two passport-size photographs", "Surety's ID proof, if bail is granted"] },
  { id: "u2", date: "2026-11-12", time: "12:00 PM", caseId: "c4", title: "State vs. Rohan Fictus", court: "Sessions Court, Mumbai", purpose: "Framing of charges" },
  { id: "u3", date: "2026-11-18", time: "10:30 AM", caseId: "c1", title: "State vs. Demo Client", court: "Sessions Court, Pune", purpose: "Cognizance of charge sheet" },
  { id: "u4", date: "2026-11-25", time: "02:30 PM", caseId: "c2", title: "State vs. Demo Client (Cyber Cell)", court: "JMFC Court, Shivajinagar, Pune", purpose: "Investigation status report" },
  { id: "u5", date: "2026-12-03", time: "10:30 AM", caseId: "c5", title: "State vs. Meera Sampleton", court: "Sessions Court, Nashik", purpose: "Prosecution evidence (PW-4)" },
];

export const ACTIVITY = [
  { id: "a1", text: "Charge sheet uploaded for Case No. 245/2025", time: "2h ago", tone: "gold" },
  { id: "a2", text: "Demo Staff replied to Demo Client", time: "4h ago", tone: "navy" },
  { id: "a3", text: "Hearing date set for State vs. Rohan Fictus", time: "Yesterday", tone: "green" },
  { id: "a4", text: "New client Kabir Placeholder added", time: "2 days ago", tone: "navy" },
];

export const THREAD = [
  { id: 1, from: "client", name: "Demo Client", time: "10:12 AM", text: "Good morning, when is the next hearing for my case?" },
  { id: 2, from: "staff", name: "Demo Staff", time: "10:20 AM", text: "Good morning. The next hearing is on 18 Nov 2026 at Sessions Court, Pune." },
  { id: 3, from: "client", name: "Demo Client", time: "10:24 AM", text: "Do I need to be present in court that day?" },
  { id: 4, from: "lawyer", name: "Adv. Demo Lawyer", time: "10:41 AM", text: "Yes, please be there by 10:30 AM. Carry your ID and a copy of the bail order." },
  { id: 5, from: "client", name: "Demo Client", time: "10:45 AM", text: "Understood, thank you. I will be there." },
];

export const CONVERSATIONS = [
  { id: "cl1", name: "Demo Client", last: "Understood, thank you. I will be there.", time: "10:45 AM", unread: 2 },
  { id: "cl2", name: "Rohan Fictus", last: "Please share the hearing order copy.", time: "Yesterday", unread: 1 },
  { id: "cl3", name: "Meera Sampleton", last: "Thank you for the update on PW-3.", time: "Mon", unread: 0 },
  { id: "cl4", name: "Kabir Placeholder", last: "I have sent the FIR copy.", time: "Sun", unread: 2 },
];

export const DOCUMENTS = [
  { id: "d1", name: "FIR Copy.pdf", size: "1.2 MB", caseNo: "Case No. 245/2025", date: "12 Aug 2025" },
  { id: "d2", name: "Bail Order.pdf", size: "860 KB", caseNo: "Case No. 245/2025", date: "14 Jan 2026" },
  { id: "d3", name: "Vakalatnama.pdf", size: "420 KB", caseNo: "Case No. 245/2025", date: "13 Aug 2025" },
];
